export default function fixAriaTag(el) {
    const searchInputs = el.find('.chosen-search-input').toArray();
    searchInputs.forEach(element => {
        element.setAttribute('aria-label','search');
    });
}
